import {
  updateNonPrimaryLanguageTranslation,
  updatePrimaryLanguageTranslation,
} from 'modules/shared-menu/pages/SharedMenuEditorPage/utils';
import { LocalisedValue, SharedMenu } from 'modules/shared-menu/types';

import { TranslationItemField } from './types';
import { Offer, Option, OptionBinding } from '../../pages/SharedMenuEditorPage/types';

export const buildUpdateOfferTranslationPayload = (
  attr: TranslationItemField,
  newValue: string,
  language: Language,
  primaryLanguage: Language,
  offer: Offer,
) => {
  const changingPrimaryLanguageTranslation = language === primaryLanguage;
  const attrCurrentTranslations: LocalisedValue[] = offer[attr] ?? [];

  const { scope, id, version, ...payloadFormatOffer } = offer;

  return {
    ...payloadFormatOffer,
    [attr]: changingPrimaryLanguageTranslation
      ? updatePrimaryLanguageTranslation(primaryLanguage, newValue, attrCurrentTranslations)
      : updateNonPrimaryLanguageTranslation(language, newValue, attrCurrentTranslations),
  };
};

export const buildUpdateCategoryTranslationPayload = (
  attr: Extract<TranslationItemField, 'name' | 'description'>,
  newValue: string,
  language: Language,
  primaryLanguage: Language,
  category: SharedMenu['categories'][number],
) => {
  const changingPrimaryLanguageTranslation = language === primaryLanguage;
  const attrCurrentTranslations: LocalisedValue[] = category[attr] ?? [];

  const { scope, id, version, ...payloadFormatCategory } = category;

  return {
    ...payloadFormatCategory,
    [attr]: changingPrimaryLanguageTranslation
      ? updatePrimaryLanguageTranslation(primaryLanguage, newValue, attrCurrentTranslations)
      : updateNonPrimaryLanguageTranslation(language, newValue, attrCurrentTranslations),
  };
};

export const buildUpdateOptionTranslationPayload = (
  attr: Extract<TranslationItemField, 'name'>,
  newValue: string,
  language: Language,
  primaryLanguage: Language,
  option: Option,
) => {
  const changingPrimaryLanguageTranslation = language === primaryLanguage;
  const attrCurrentTranslations: LocalisedValue[] = option[attr] ?? [];

  const { scope, id, version, ...payloadShapedOption } = option;

  return {
    ...payloadShapedOption,
    [attr]: changingPrimaryLanguageTranslation
      ? updatePrimaryLanguageTranslation(primaryLanguage, newValue, attrCurrentTranslations)
      : updateNonPrimaryLanguageTranslation(language, newValue, attrCurrentTranslations),
  };
};

export const buildOptionValueTranslation = (
  attr: Extract<
    TranslationItemField,
    | 'name'
    | 'ingredients'
    | 'additives'
    | 'nutrition_facts'
    | 'allergens'
    | 'producer_information'
    | 'distributor_information'
  >,
  newValue: string,
  language: Language,
  primaryLanguage: Language,
  optionValue: Option['values'][number],
) => {
  const changingPrimaryLanguageTranslation = language === primaryLanguage;
  const attrCurrentTranslations: LocalisedValue[] = optionValue[attr] ?? [];

  return {
    ...optionValue,
    [attr]: changingPrimaryLanguageTranslation
      ? updatePrimaryLanguageTranslation(primaryLanguage, newValue, attrCurrentTranslations)
      : updateNonPrimaryLanguageTranslation(language, newValue, attrCurrentTranslations),
  };
};

export const buildUpdateOptionBindingTranslationPayload = (
  attr: Extract<TranslationItemField, 'name'>,
  newValue: string,
  language: Language,
  primaryLanguage: Language,
  optionBinding: OptionBinding,
) => {
  const changingPrimaryLanguageTranslation = language === primaryLanguage;
  const attrCurrentTranslations: LocalisedValue[] = optionBinding[attr] ?? [];

  return {
    ...optionBinding,
    [attr]: changingPrimaryLanguageTranslation
      ? updatePrimaryLanguageTranslation(primaryLanguage, newValue, attrCurrentTranslations)
      : updateNonPrimaryLanguageTranslation(language, newValue, attrCurrentTranslations),
  };
};
